<template> 
    <div>
        <nav class="main_nav" v-if="isOpen">
            <ul>
                <li class="main_nav_h" v-for="menu in $store.state.menu_list" :key="menu.category_no">
                    <span>{{menu.category_name}}</span>
                    <ul v-if="menu.sub_menu != null && menu.sub_menu.length > 0">
                        <li v-for="sub_menu in menu.sub_menu" :key="sub_menu.category_no" @click="menuLink(sub_menu)" :class="$store.state.menu_no==sub_menu.category_no?'li_select':''">
                            <a href="#">{{sub_menu.category_name}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <!-- 배경레이어 -->
        <div class="popup_layer" v-if="isOpen"></div>
        <!--// 배경레이어 -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false
        }
    },
    created() {
        // 메뉴정보가 없으면 메뉴 정보 로드
        //if(this.$store.state.menu_list.length == 0) {
        this.getMenuList();
        //}
    },
    methods: {
        getMenuList() {
            this.$http.get('/api/menu.do').then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    var menu_list = [];
                    var menu = null;

                    for(var i=0; i<response.data.category.length; i++) {
                        // 1차 메뉴 세팅
                        if(response.data.category[i].depth == 1) {
                            if(menu != null) {
                                menu_list.push(menu);
                            }

                            menu = response.data.category[i];
                            menu.sub_menu = [];
                        // 2차 메뉴 세팅
                        } else {
                            if(menu.category_no == response.data.category[i].p_no) {
                                menu.sub_menu.push(response.data.category[i]);
                            }
                        }
                    }

                    menu_list.push(menu);

                    this.$store.commit('setMenuList', menu_list);
                }
            });
        },
        menuLink(menu) {
            this.$store.commit('setMenuNo', menu);
            this.isOpen = false;

            // 게시판 타입
            if(menu.page_type == this.CONSTANT.PAGE_TYPE_BOARD) {
                this.$router.push('/m/board/'+menu.category_no);
            // 콜 접수
            } else if(menu.page_type == this.CONSTANT.PAGE_TYPE_LINK) {                
                this.$router.push('/m'+menu.link_url);
            // 일반 서브 페이지
            } else {
                this.$router.push('/m/sub/'+menu.category_no);
            }
        },
        sideMenuToggle(isOpen) {
            if(isOpen != null) {
                this.isOpen = isOpen;
            } else {
                this.isOpen = !this.isOpen;
            }

            if(this.isOpen) {
                window.scrollTo(0, 0);
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/common/SideMenu.vue